module.exports = __webpack_public_path__ + "static/Chubb3-445f921245cba95b353c3947f37f352b.png";